import { render, staticRenderFns } from "./ShopUserMoney.vue?vue&type=template&id=91dd8bb2&scoped=true"
import script from "./ShopUserMoney.vue?vue&type=script&lang=js"
export * from "./ShopUserMoney.vue?vue&type=script&lang=js"
import style0 from "./ShopUserMoney.vue?vue&type=style&index=0&id=91dd8bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dd8bb2",
  null
  
)

export default component.exports